/* AXIN Güvenlik — "Sistemini Kur" sihirbazı (sürüm 3, 21.09.2026)
 *
 * İki yol:
 *  1) İhtiyaç listesi -> WhatsApp'a hazır mesaj (ad/telefon zorunlu değil).
 *  2) Hazır set önerisi: YALNIZ mağazada satışta + stoklu ürünlerden kurulur
 *     (assets/set-calc-data.json -> "magaza", set_hesap_fiyat.py her sabah
 *     canlı Shopify'dan üretir). Fiyat = ürün sayfası / sepet fiyatı; sayfa
 *     açılışında /products/<handle>.js ile canlı teyit edilir.
 *
 * Teknik uyum kuralları (kodla):
 *  - AHD kamera + XVR, IP kamera + NVR.
 *  - NVR'ın PoE port sayısı yetmezse PoE switch eklenir (en ucuz toplam).
 *  - Kayıt cihazının kayıt çözünürlüğü (katalog/ad kanıtı) kameradan düşükse
 *    sonuçta açıkça yazılır; çözünürlüğü kanıtsız cihaz seçilmez.
 *  - Disk: gün x kamera x bitrate; bitrate D.magaza.mbps (kaynak:
 *    _aciklama_denetim_25_kayitgun.KOTU, H.265 normal, hareketli sahne,
 *    sürekli kayıt). İhtiyacın bir üst kademesi seçilir.
 *  - Ses istenirse yalnız mikrofonlu model (kanıt: ürün adı ya da katalog).
 *  - Kurulum hizmeti önerilmez.
 */
(function () {
  "use strict";
  var root = document.getElementById("axin-calc");
  if (!root) return;
  var DATA_URL = root.getAttribute("data-json");
  var WA = (root.getAttribute("data-whatsapp") || "").replace(/\D/g, "");
  var PHONE = root.getAttribute("data-phone") || "";
  var D = null, M = null;
  var WA_AZAMI = 1900; // wa.me URL üst sınırı (tarayıcı/uygulama güvenli bölge)

  var MEKAN = [["ev", "Apartman dairesi"], ["mustakil", "Müstakil ev / villa"], ["apartman", "Apartman ortak alanı"], ["isyeri", "İşyeri / mağaza"], ["depo", "Depo / fabrika / şantiye"]];
  var BUTCE = [["", "Belirtmek istemiyorum"], ["0-15000", "15.000 TL'ye kadar"], ["15000-30000", "15.000 – 30.000 TL"], ["30000-60000", "30.000 – 60.000 TL"], ["60000-120000", "60.000 – 120.000 TL"], ["120000-", "120.000 TL üzeri"]];
  var EK = ["Monitör", "Alarm sistemi", "4G internet (hat yok)", "Kurumsal fatura", "Uzak mesafe kablolama", "Plaka / yüz okuma"];

  function yeniDurum() {
    return { adim: 0, mekan: "", ic: 0, dis: 2, sis: "oner", mp: 0, gece: "ir", gun: 15, ses: false, ups: false, tel: true, butce: "", ek: [], not: "", ad: "", telno: "", haric: {} };
  }
  var st = yeniDurum();
  var ADIMLAR = ["Mekân", "Görüntü", "Kayıt & güç", "Bütçe", "Sonuç"];

  var TLf = new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function tl(n) { return TLf.format(n) + " TL"; }
  function tl0(n) { return new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 0 }).format(n) + " TL"; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function n() { return (st.ic || 0) + (st.dis || 0); }

  fetch(DATA_URL).then(function (r) { return r.json(); }).then(function (j) {
    D = j; M = j.magaza || null; ciz();
  }).catch(function () {
    root.innerHTML = '<div class="ak-hata">Sihirbaz yüklenemedi. Sayfayı yenileyin ya da WhatsApp\'tan yazın.</div>';
  });

  /* ------------------------------------------------------------ seçimler */
  function sistem() {
    if (st.sis !== "oner") return st.sis;
    // Öneri: stoktaki XVR'ların çoğu 1080N kaydeder; 2MP üstü ya da 16+ kamera IP.
    return ((st.mp && st.mp > 2) || n() > 16) ? "IP" : "AHD";
  }
  function cozunurluk() { return st.mp || (sistem() === "IP" ? 4 : 2); }
  function mpEtiket(mp) { return { 2: "2MP (1080p)", 3: "3MP", 4: "4MP (2K)", 5: "5MP", 6: "6MP", 8: "8MP (4K)" }[mp] || mp + "MP"; }
  function kayitEtiket(r) { if (!r || !r.kmp) return "?"; if (r.kmp === 2 && r.kmp_n) return "1080N"; return r.kmp + "MP" + (r.kmp_n ? "-N" : ""); }
  function mbps(mp) {
    var t = (M && M.mbps) || {}, anahtar = Object.keys(t).map(Number).sort(function (a, b) { return a - b; });
    for (var i = 0; i < anahtar.length; i++) if (anahtar[i] >= mp) return t[String(anahtar[i])];
    return t[String(anahtar[anahtar.length - 1])] || 8;
  }
  function kisaAd(ad) { return String(ad).replace(/^Tplink-Vigi\s+/i, "").replace(/\s+/g, " ").slice(0, 90); }
  // WhatsApp mesajında kısa ad: AXIN'in kendi ürünlerinde " - " öncesi, diğerlerinde marka + model kodu
  function model(ad) {
    var s = String(ad).replace(/^Tplink-Vigi\s+/i, "").replace(/\s+/g, " ").trim();
    if (s.indexOf(" - ") > 0) return s.split(" - ")[0].slice(0, 40);
    var t = s.split(" "), birim = /^\d+([.,]\d+)?(MP|MM|TB|GB|MB|VA|KVA|W|V|A|AH|RPM|MT|M|METRE|AWG|PORT)$/i;
    for (var i = 1; i < t.length; i++) {
      var x = t[i];
      if (x.length >= 5 && /[A-Z]/i.test(x) && /\d/.test(x) && !birim.test(x) && !/^SATA\d|^\d+F\/\d+F$|^\(?\d+X\d+AH\)?$|^H26[45]|^\d+\/\d+/i.test(x)) return t[0] + " " + x;
    }
    return t.slice(0, 3).join(" ");
  }

  /* ------------------------------------------------------------ set motoru */
  function kur() {
    var S = sistem(), MP = cozunurluk(), N = n(), out = { kalem: [], toplam: 0, not: [], uyari: [], eksik: [], S: S, MP: MP };
    if (!M) { out.eksik.push("Mağaza kataloğu yüklenemedi"); return out; }
    var H = st.haric;
    function ekle(tur, u, adet, aciklama) {
      if (!u || adet <= 0) return;
      out.kalem.push({ tur: tur, u: u, adet: adet, satir: Math.round(u.p * adet * 100) / 100, aciklama: aciklama || "" });
    }
    function uygunStok(u, adet) { return !H[u.v] && u.s >= adet; }

    // 1) Kameralar — istenen MP, yoksa en yakın üst MP (en çok 8)
    var kamMP = 0;
    [["ic", st.ic, "İç mekân"], ["dis", st.dis, "Dış mekân"]].forEach(function (g) {
      if (!g[1]) return;
      var aday = M.kamera.filter(function (k) {
        return k.sis === S && k.ort.indexOf(g[0]) >= 0 && (!st.ses || k.mik) && (st.gece !== "renkli" || k.renk !== "ir") && uygunStok(k, g[1]) && k.mp >= MP && k.mp <= 8;
      });
      var enYakin = aday.reduce(function (a, k) { return Math.min(a, k.mp); }, 99);
      aday = aday.filter(function (k) { return k.mp === enYakin; });
      if (!aday.length) {
        out.eksik.push(g[1] + " adet " + g[2].toLowerCase() + " " + MP + "MP " + S + " kamera" + (st.ses ? " (mikrofonlu)" : "") + (st.gece === "renkli" ? " (gece renkli)" : ""));
        return;
      }
      var k = aday[0]; // katalog fiyata göre sıralı
      if (k.mp > MP) out.not.push(g[2] + " için " + MP + "MP stokta yok; " + k.mp + "MP model önerildi.");
      var acik = [g[2], k.mp + "MP"];
      if (k.mik) acik.push("mikrofonlu" + (k.mk === "katalog" ? " (katalog)" : ""));
      acik.push(k.renk === "tam" ? "gece renkli" : k.renk === "akilli" ? "akıllı ışık: hareket olunca renkli" : "gece siyah-beyaz (IR)");
      ekle("kamera", k, g[1], acik.join(" · "));
      kamMP = Math.max(kamMP, k.mp);
    });
    if (!N) out.eksik.push("kamera sayısı");

    // 2) Kayıt cihazı — AHD->XVR, IP->NVR; kanal >= kamera; çözünürlüğü kanıtlı
    var poeFn = function (ihtiyac) { // en ucuz PoE switch toplamı
      if (ihtiyac <= 0) return { p: 0, sw: null, adet: 0 };
      var eniyi = null;
      M.poe.forEach(function (sw) {
        var adet = Math.ceil(ihtiyac / sw.port);
        if (!uygunStok(sw, adet) || adet > 2) return;
        var p = sw.p * adet;
        if (!eniyi || p < eniyi.p) eniyi = { p: p, sw: sw, adet: adet };
      });
      return eniyi;
    };
    var kayitlar = M.kayit.filter(function (r) { return r.sis === S && r.kanal >= N && r.kmp && uygunStok(r, 1) && r.kanal <= Math.max(16, N * 2); });
    var tam = kayitlar.filter(function (r) { return r.kmp >= kamMP; });
    var havuz = tam.length ? tam : kayitlar.slice().sort(function (a, b) { return b.kmp - a.kmp || a.p - b.p; }).filter(function (r, i, a) { return r.kmp === a[0].kmp; });
    var sec = null;
    havuz.forEach(function (r) {
      var ps = S === "IP" ? poeFn(N - (r.poe || 0)) : { p: 0 };
      if (!ps) return;
      var p = r.p + ps.p;
      if (!sec || p < sec.p) sec = { p: p, r: r, ps: ps };
    });
    var R = sec && sec.r;
    if (!R && N) out.eksik.push(N + " kanal " + (S === "IP" ? "NVR" : "XVR") + " kayıt cihazı");
    if (R) {
      var ra = [R.kanal + " kanal", "kayıt " + kayitEtiket(R)];
      if (S === "IP") ra.push(R.poe ? R.poe + " PoE port" : "PoE yok");
      ekle("kayit", R, 1, ra.join(" · "));
      if (kamMP && R.kmp < kamMP) out.uyari.push("Kayıt cihazı en çok " + kayitEtiket(R) + " kaydeder; kameralar " + kamMP + "MP. Kayıtlar " + kayitEtiket(R) + " çözünürlükte olur (canlı izleme de sınırlı olabilir). Tam çözünürlük için stokta uygun cihaz yok — WhatsApp'tan sorun.");
      else if (R.kmp_n) out.not.push("Kayıt cihazı " + kayitEtiket(R) + " kaydeder (N: yatayda yarı çözünürlük, disk tasarrufu).");
      if (S === "IP" && sec.ps && sec.ps.sw) {
        ekle("poe", sec.ps.sw, sec.ps.adet, sec.ps.sw.port + " port PoE — kayıt cihazının PoE portu " + (R.poe || 0) + ", kamera " + N);
      }
    }

    // 3) Disk — gün x kamera x bitrate, bir üst kademe
    if (R) {
      var effMP = Math.min(kamMP || MP, R.kmp);
      var gunluk = mbps(effMP) * 86400 / 8 / 1000; // GB / gün / kamera
      var gerek = gunluk * N * st.gun;
      var yuva = R.sata || 1, tavan = R.tbmax ? R.tbmax * 1000 : 1e9, dsec = null;
      M.disk.forEach(function (d) {
        if (d.gb > tavan) return;
        for (var k = 1; k <= yuva; k++) {
          if (d.gb * k >= gerek && uygunStok(d, k)) {
            var p = d.p * k;
            if (!dsec || d.gb * k < dsec.gb * dsec.k || (d.gb * k === dsec.gb * dsec.k && p < dsec.p)) dsec = { d: d, k: k, p: p, gb: d.gb };
            break;
          }
        }
      });
      if (!dsec) {
        M.disk.forEach(function (d) { if (d.gb <= tavan && uygunStok(d, yuva)) { if (!dsec || d.gb > dsec.gb) dsec = { d: d, k: yuva, p: d.p * yuva, gb: d.gb }; } });
        if (dsec) out.uyari.push("İstenen " + st.gun + " gün için yeterli disk kapasitesi stokta yok; önerilen disk yaklaşık " + Math.floor(dsec.gb * dsec.k / (gunluk * N)) + " gün kaydeder.");
      }
      if (dsec) {
        var gunKap = Math.floor(dsec.gb * dsec.k / (gunluk * N || 1));
        ekle("disk", dsec.d, dsec.k, (dsec.gb >= 1000 ? dsec.gb / 1000 + " TB" : dsec.gb + " GB") + " · ihtiyaç ≈ " + Math.ceil(gerek) + " GB · ≈ " + gunKap + " gün sürekli kayıt");
        out.gunKap = gunKap;
        if (!R.tbmax && dsec.gb > 8000) out.not.push("Kayıt cihazının desteklediği en büyük disk boyutu katalogda yazmıyor; " + dsec.gb / 1000 + " TB disk için WhatsApp'tan teyit alın.");
      } else out.eksik.push("güvenlik diski");
      out.bitrate = { mbps: mbps(effMP), mp: effMP };
    }

    // 4) Kablolama ve güç
    var A = M.aks || {};
    function ucuz(liste, adet, tercih) {
      var L = (liste || []).filter(function (u) { return uygunStok(u, adet); });
      if (tercih) { var t = L.filter(function (u) { return tercih.test(u.ad); }); if (t.length) return t[0]; }
      return L[0] || null;
    }
    if (N && S === "IP") {
      var rulo = Math.ceil(N * 40 / 305);
      var c6 = ucuz((A.cat6 || []).filter(function (u) { return u.n >= 305 && u.n <= 305; }), rulo, st.dis ? /OUTDOOR|PE /i : null);
      if (c6) ekle("aks", c6, rulo, "kamera başına ≈40 m varsayımı" + (st.dis && !/OUTDOOR|PE /i.test(c6.ad) ? " · dış hat için UV dayanımlı kablo gerekebilir" : ""));
      else out.eksik.push("Cat6 kablo (305 m)");
      var rj = ucuz(A.rj45, 1);
      if (rj) { var pk = Math.ceil(2 * N / (rj.n || 100)); ekle("aks", rj, pk, "kablo başına 2 uç"); }
      var bu = ucuz(A.buat, st.dis);
      if (bu && st.dis) ekle("aks", bu, st.dis, "dış kamera başına 1");
    } else if (N && S === "AHD") {
      var metre = N * 20, yuz = Math.floor(metre / 100), kalan = metre - yuz * 100;
      var k100 = (A.cctv || []).filter(function (u) { return u.n === 100; }), k50 = (A.cctv || []).filter(function (u) { return u.n === 50; });
      var elli = 0; if (kalan > 50) yuz++; else if (kalan > 0) elli = 1;
      var c100 = ucuz(k100, yuz), c50 = ucuz(k50, elli);
      if (elli && !c50 && c100) { yuz++; elli = 0; }
      if (yuz && c100) ekle("aks", c100, yuz, "kamera başına ≈20 m varsayımı");
      if (elli && c50) ekle("aks", c50, elli, "");
      if ((yuz && !c100)) out.eksik.push("CCTV 2+1 kablo");
      var bnc = ucuz(A.bnc, 2 * N), jak = ucuz(A.jak, N);
      if (bnc) ekle("aks", bnc, 2 * N, "kamera başına 2 BNC");
      if (jak) ekle("aks", jak, N, "kamera başına 1 güç jakı");
      var amp = N <= 4 ? 10 : N <= 8 ? 15 : 20, adpAdet = N <= 16 ? 1 : Math.ceil(N / 8);
      var adp = ucuz((A.adp || []).filter(function (u) { return u.n === amp; }), adpAdet);
      if (adp) ekle("aks", adp, adpAdet, "12V " + amp + "A — " + N + " kamera için");
      else out.eksik.push("12V " + amp + "A adaptör");
      var ba = ucuz(A.buat, N);
      if (ba) ekle("aks", ba, N, "kamera başına 1");
    }

    // 5) UPS — yük: kayıt cihazı 15 W + disk 8 W + kamera (PoE 802.3af üst sınırı 12,95 W / AHD 12 V 1 A)
    if (st.ups && N) {
      var diskAdet = out.kalem.filter(function (x) { return x.tur === "disk"; }).reduce(function (a, x) { return a + x.adet; }, 0);
      var w = 15 + 8 * diskAdet + N * (S === "IP" ? 12.95 : 12);
      var va = Math.max(600, Math.ceil(w / 0.6));
      var ups = (M.ups || []).filter(function (u) { return u.va >= va && uygunStok(u, 1); })[0];
      if (ups) ekle("ups", ups, 1, "yük ≈ " + Math.round(w) + " W · gereken ≥ " + va + " VA");
      else out.eksik.push("UPS (≥ " + va + " VA)");
    }
    if (st.tel) out.not.push("Telefondan izleme: kayıt cihazı modeme bağlanınca üreticinin ücretsiz uygulamasıyla izlenir (internet gerekir).");
    if (st.ses && S === "AHD") out.not.push("AHD'de ses kaydı, kayıt cihazının koaksiyel ses desteğine bağlıdır; emin olmak için WhatsApp'tan sorun.");
    out.toplam = Math.round(out.kalem.reduce(function (a, x) { return a + x.satir; }, 0) * 100) / 100;
    if (st.butce) {
      var bs = st.butce.split("-"), ust = Number(bs[1] || 0);
      if (ust && out.toplam > ust) out.uyari.push("Önerilen set bütçenizin (" + BUTCE.filter(function (b) { return b[0] === st.butce; })[0][1] + ") üstünde. Daha ekonomik seçenek için WhatsApp'tan yazın.");
    }
    return out;
  }

  /* ------------------------------------------------------------ canlı teyit */
  var canliOnbellek = {};
  function canliTeyit(set) {
    var hlar = {}; set.kalem.forEach(function (x) { hlar[x.u.h] = 1; });
    var isler = Object.keys(hlar).map(function (h) {
      if (canliOnbellek[h]) return Promise.resolve(canliOnbellek[h]);
      return fetch("/products/" + encodeURIComponent(h) + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (j) { canliOnbellek[h] = j; return j; })
        .catch(function () { return null; });
    });
    return Promise.all(isler).then(function (jl) {
      var vmap = {};
      jl.forEach(function (j) { if (j) (j.variants || []).forEach(function (v) { vmap[v.id] = v; }); });
      var degisti = false, cikar = false;
      set.kalem.forEach(function (x) {
        var v = vmap[x.u.v];
        if (!v || !v.available) { st.haric[x.u.v] = 1; cikar = true; return; }
        var p = Math.round(v.price) / 100;
        if (Math.abs(p - x.u.p) > 0.005) { x.u.p = p; degisti = true; }
      });
      return { cikar: cikar, degisti: degisti };
    });
  }

  /* ------------------------------------------------------------ WhatsApp */
  function secimSatirlari() {
    var L = [], mk = MEKAN.filter(function (m) { return m[0] === st.mekan; })[0];
    if (mk) L.push("Mekân: " + mk[1]);
    L.push("Kamera: " + n() + " (" + st.ic + " iç, " + st.dis + " dış)");
    L.push("Sistem: " + (st.sis === "oner" ? "önerinize bırakıyorum" : st.sis) + ", " + (st.mp ? st.mp + "MP" : "çözünürlük önerinize"));
    L.push("Gece görüşü: " + (st.gece === "renkli" ? "renkli" : "siyah-beyaz yeterli"));
    L.push("Kayıt süresi: " + st.gun + " gün");
    L.push("Ses kaydı: " + (st.ses ? "evet" : "hayır"));
    L.push("Elektrik kesintisi (UPS): " + (st.ups ? "evet" : "hayır"));
    L.push("Telefondan izleme: " + (st.tel ? "evet" : "hayır"));
    var b = BUTCE.filter(function (x) { return x[0] === st.butce; })[0];
    if (st.butce && b) L.push("Bütçe: " + b[1]);
    if (st.ek.length) L.push("Ek istek: " + st.ek.join(", "));
    return L;
  }
  function kisiSatirlari() {
    var L = [];
    if (st.not) L.push("Not: " + st.not.slice(0, 300));
    if (st.ad || st.telno) L.push("İletişim: " + [st.ad, st.telno].filter(Boolean).join(" · "));
    return L;
  }
  function metinIhtiyac() {
    return ["Merhaba, axinguvenlik.com'daki sihirbazla ihtiyacımı hazırladım:", ""]
      .concat(secimSatirlari().map(function (s) { return "- " + s; }), kisiSatirlari().map(function (s) { return "- " + s; }))
      .concat(["", "Uygun sistem ve fiyat bilgisi rica ederim."]).join("\n");
  }
  function metinSet(set, kisa) {
    var L = ["Merhaba, sitenizdeki sihirbazın önerdiği bu seti sormak istiyorum:", ""];
    set.kalem.forEach(function (x) { L.push("- " + x.adet + " x " + model(x.u.ad) + (kisa ? "" : " (" + tl0(x.satir) + ")")); });
    L.push("Toplam: " + tl(set.toplam) + " (" + (D.uretim || "") + " fiyatı)");
    L.push("", "Seçimlerim: " + secimSatirlari().join("; "));
    kisiSatirlari().forEach(function (s) { L.push(s); });
    return L.join("\n");
  }
  function waUrl(metin) { return "https://wa.me/" + WA + "?text=" + encodeURIComponent(metin); }
  function waSet(set) {
    var u = waUrl(metinSet(set, false));
    if (u.length > WA_AZAMI) u = waUrl(metinSet(set, true));
    if (u.length > WA_AZAMI) u = waUrl(metinSet(set, true).slice(0, 700));
    return u;
  }
  function waIhtiyac() {
    var u = waUrl(metinIhtiyac());
    if (u.length > WA_AZAMI) { var asil = st.not; st.not = asil.slice(0, 60); u = waUrl(metinIhtiyac()); st.not = asil; }
    if (u.length > WA_AZAMI) u = waUrl(metinIhtiyac().slice(0, 600));
    return u;
  }

  /* ------------------------------------------------------------ sepet */
  function sepeteEkle(set, btn, msg) {
    btn.disabled = true; btn.textContent = "Sepete ekleniyor…";
    var items = set.kalem.map(function (x) { return { id: x.u.v, quantity: x.adet }; });
    var kok = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    fetch(kok + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (s) {
        if (!s.ok) throw new Error((s.j && (s.j.description || s.j.message)) || "Sepete eklenemedi");
        window.__axinSepet = s.j;
        msg.innerHTML = "Set sepete eklendi. Sepete yönlendiriliyorsunuz…";
        if (!window.__axinTest) window.location.href = kok + "cart";
        btn.textContent = "Sepete eklendi ✓";
      })
      .catch(function (e) {
        btn.disabled = false; btn.textContent = "Tüm seti sepete ekle";
        msg.innerHTML = '<span class="ak-kirmizi">' + esc(e.message) + '</span> — stok değişmiş olabilir. Bu seti WhatsApp\'tan sorabilirsiniz.';
      });
  }

  /* ------------------------------------------------------------ arayüz */
  function ciz() {
    root.innerHTML = "";
    var bas = el("div", "ak-bas" + (st.adim ? " kisa" : ""));
    bas.innerHTML = '<p class="ak-ust">AXIN Güvenlik · ücretsiz sistem planlama</p><h1>Kamera sistemini birlikte kuralım</h1><p>5 kısa adım. Sonunda stoktaki ürünlerle hazır set önerisi ya da ihtiyaç listeniz WhatsApp\'a hazır mesaj olarak gelir.</p>';
    root.appendChild(bas);
    var ilerle = el("div", "ak-ilerle");
    ilerle.innerHTML = '<div class="ak-ilerle-u">Adım ' + (st.adim + 1) + ' / 5 · <b>' + ADIMLAR[st.adim] + '</b></div><div class="ak-bar">' +
      ADIMLAR.map(function (a, i) { return '<span class="' + (i <= st.adim ? "on" : "") + '"></span>'; }).join("") + "</div>";
    root.appendChild(ilerle);
    var govde = el("div", "ak-govde");
    root.appendChild(govde);
    [adim1, adim2, adim3, adim4, adim5][st.adim](govde);
  }
  function git(i) { st.adim = i; ciz(); var y = root.getBoundingClientRect().top + window.pageYOffset - 12; if (window.pageYOffset > y) window.scrollTo({ top: y, behavior: "smooth" }); }
  function baslik(p, t, alt) { p.appendChild(el("h2", "ak-h2", t)); if (alt) p.appendChild(el("p", "ak-alt", alt)); }
  function grup(p, etiket, ipucu) { var g = el("div", "ak-grup"); g.appendChild(el("div", "ak-etiket", etiket + (ipucu ? ' <span class="ak-ipucu">' + ipucu + "</span>" : ""))); p.appendChild(g); return g; }
  function secenekler(p, liste, deger, fn, genis) {
    var w = el("div", "ak-sec" + (genis ? " genis" : ""));
    liste.forEach(function (o) {
      var b = el("button", "ak-cip" + (o[0] === deger ? " on" : ""));
      b.type = "button"; b.setAttribute("aria-pressed", o[0] === deger ? "true" : "false");
      b.innerHTML = "<b>" + o[1] + "</b>" + (o[2] ? "<small>" + o[2] + "</small>" : "");
      b.onclick = function () { fn(o[0]); ciz(); };
      w.appendChild(b);
    });
    p.appendChild(w);
  }
  function sayac(p, etiket, anahtar, alt) {
    var w = el("div", "ak-sayac");
    w.innerHTML = '<div><b>' + etiket + '</b><small>' + alt + '</small></div>';
    var c = el("div", "ak-sayac-c");
    var eks = el("button", "ak-sbtn", "−"), val = el("span", "ak-sval", String(st[anahtar])), art = el("button", "ak-sbtn", "+");
    eks.type = art.type = "button"; eks.setAttribute("aria-label", etiket + " azalt"); art.setAttribute("aria-label", etiket + " artır");
    eks.onclick = function () { if (st[anahtar] > 0) { st[anahtar]--; ciz(); } };
    art.onclick = function () { if (n() < 32) { st[anahtar]++; ciz(); } };
    c.appendChild(eks); c.appendChild(val); c.appendChild(art); w.appendChild(c); p.appendChild(w);
  }
  function gezinti(p, geri, ileri, etiket, aktif) {
    var r = el("div", "ak-gez");
    if (geri != null) { var g = el("button", "ak-btn ikincil", "Geri"); g.type = "button"; g.onclick = function () { git(geri); }; r.appendChild(g); } else r.appendChild(el("span"));
    if (ileri != null) { var i = el("button", "ak-btn", etiket || "Devam"); i.type = "button"; i.disabled = !aktif; i.onclick = function () { git(ileri); }; r.appendChild(i); }
    p.appendChild(r);
  }

  function adim1(p) {
    baslik(p, "Nereyi korumak istiyorsunuz?", "Mekânı ve kamera sayısını seçin. Kamera sayısını bilmiyorsanız tahmini girin; sonra WhatsApp'tan birlikte netleştiririz.");
    secenekler(grup(p, "Mekân"), MEKAN, st.mekan, function (v) { st.mekan = v; }, true);
    var g = grup(p, "Kamera sayısı", "en çok 32");
    sayac(g, "İç mekân", "ic", "salon, giriş, kasa, koridor");
    sayac(g, "Dış mekân", "dis", "bahçe, kapı, otopark, cephe");
    g.appendChild(el("div", "ak-bilgi", "Toplam <b>" + n() + "</b> kamera"));
    gezinti(p, null, 1, "Devam", n() > 0);
  }
  function adim2(p) {
    baslik(p, "Görüntü kalitesi", "Emin değilseniz \"Siz önerin\" seçili kalsın.");
    secenekler(grup(p, "Sistem tipi"), [["oner", "Siz önerin", ""], ["AHD", "AHD (analog HD)", "Koaksiyel kablo, ekonomik"], ["IP", "IP kamera", "Tek ağ kablosu, yüksek çözünürlük"]], st.sis, function (v) { st.sis = v; });
    p.appendChild(el("p", "ak-terim", "<b>PoE</b> (Power over Ethernet): IP kamera tek ağ kablosundan hem görüntü hem elektrik alır; ayrı adaptör gerekmez."));
    secenekler(grup(p, "Çözünürlük"), [[0, "Siz önerin", ""], [2, "2MP", "1080p Full HD"], [4, "4MP", "2K, daha net yüz"], [5, "5MP", "geniş alan"], [8, "8MP", "4K, en net"]], st.mp, function (v) { st.mp = v; });
    secenekler(grup(p, "Gece görüşü"), [["ir", "Siyah-beyaz (IR)", "karanlıkta kızılötesi"], ["renkli", "Renkli", "gece de renkli görüntü"]], st.gece, function (v) { st.gece = v; });
    gezinti(p, 0, 2, "Devam", true);
  }
  function adim3(p) {
    baslik(p, "Kayıt ve güç", "");
    secenekler(grup(p, "Geriye dönük kayıt", "disk buna göre seçilir"), [[7, "7 gün", ""], [15, "15 gün", ""], [30, "30 gün", ""]], st.gun, function (v) { st.gun = v; });
    p.appendChild(el("p", "ak-terim", "<b>H.265</b>: görüntüyü sıkıştıran kayıt standardı; aynı diskte daha uzun kayıt sağlar. Disk hesabı en yüksek kalitede sürekli kayda göre yapılır."));
    secenekler(grup(p, "Ses kaydı"), [[false, "Gerekmez", ""], [true, "Evet, sesli", "yalnız mikrofonlu kameralar"]], st.ses, function (v) { st.ses = v; });
    secenekler(grup(p, "Elektrik kesintisi"), [[false, "Önemli değil", ""], [true, "Kayıt sürsün", "UPS (kesintisiz güç kaynağı) eklenir"]], st.ups, function (v) { st.ups = v; });
    secenekler(grup(p, "Telefondan izleme"), [[true, "Evet", "internet gerekir"], [false, "Gerekmez", ""]], st.tel, function (v) { st.tel = v; });
    gezinti(p, 1, 3, "Devam", true);
  }
  function adim4(p) {
    baslik(p, "Bütçe ve notlar", "Hepsi isteğe bağlı.");
    secenekler(grup(p, "Bütçe aralığı"), BUTCE, st.butce, function (v) { st.butce = v; }, true);
    var g = grup(p, "Ek istekler");
    var w = el("div", "ak-sec");
    EK.forEach(function (e) {
      var on = st.ek.indexOf(e) >= 0, b = el("button", "ak-cip kucuk" + (on ? " on" : ""), "<b>" + e + "</b>");
      b.type = "button"; b.setAttribute("aria-pressed", on ? "true" : "false");
      b.onclick = function () { if (on) st.ek.splice(st.ek.indexOf(e), 1); else st.ek.push(e); ciz(); };
      w.appendChild(b);
    });
    g.appendChild(w);
    var g2 = grup(p, "Not");
    var ta = el("textarea", "ak-girdi"); ta.rows = 3; ta.maxLength = 300; ta.placeholder = "Örn. kapı önü plakayı görsün, bahçe 30 metre"; ta.value = st.not;
    ta.oninput = function () { st.not = ta.value; }; g2.appendChild(ta);
    var g3 = grup(p, "Adınız ve telefonunuz", "zorunlu değil");
    var r = el("div", "ak-iki");
    var ad = el("input", "ak-girdi"); ad.placeholder = "Ad"; ad.value = st.ad; ad.maxLength = 40; ad.autocomplete = "name"; ad.oninput = function () { st.ad = ad.value; };
    var tel = el("input", "ak-girdi"); tel.type = "tel"; tel.placeholder = "Telefon"; tel.value = st.telno; tel.maxLength = 20; tel.autocomplete = "tel"; tel.oninput = function () { st.telno = tel.value; };
    r.appendChild(ad); r.appendChild(tel); g3.appendChild(r);
    gezinti(p, 2, 4, "Sonucu gör", true);
  }

  var sonSet = null;
  function adim5(p) {
    var set = kur();
    sonSet = set;
    var kutu = el("div", "ak-sonuc");
    p.appendChild(kutu);
    kutu.appendChild(el("div", "ak-yukle", "Stok ve fiyatlar mağazadan kontrol ediliyor…"));
    var deneme = 0;
    (function dongu() {
      if (!set.kalem.length) return goster(set, kutu, p);
      canliTeyit(set).then(function (s) {
        if (s.cikar && deneme++ < 3) { set = kur(); sonSet = set; return dongu(); }
        if (s.degisti) set.toplam = Math.round(set.kalem.reduce(function (a, x) { x.satir = Math.round(x.u.p * x.adet * 100) / 100; return a + x.satir; }, 0) * 100) / 100;
        set.canli = new Date();
        goster(set, kutu, p);
      });
    })();
  }
  function goster(set, kutu, p) {
    kutu.innerHTML = "";
    var ozet = el("div", "ak-ozet");
    ozet.innerHTML = "<b>" + n() + " kamera</b> · " + set.S + " · " + mpEtiket(set.MP) + " · " + st.gun + " gün · " + (st.gece === "renkli" ? "gece renkli" : "gece IR") + (st.ses ? " · sesli" : "") + (st.ups ? " · UPS" : "");
    kutu.appendChild(ozet);

    // YOL 2 — Hazır set
    var kart = el("section", "ak-kart");
    kart.appendChild(el("h2", "ak-h2", "Stoktaki ürünlerle önerilen set"));
    var tam = set.kalem.length && !set.eksik.length;
    if (!tam) {
      kart.appendChild(el("div", "ak-dur", "<b>Bu seçim için eksiksiz set kuramadık.</b> Stokta karşılığı olmayan: " + esc(set.eksik.join(", ")) + ". İhtiyacınızı WhatsApp'tan gönderin; tedarikten ya da alternatifle hızlıca dönelim."));
    } else {
      var tb = el("div", "ak-liste");
      set.kalem.forEach(function (x) {
        var a = el("div", "ak-satir");
        a.innerHTML = '<div class="ak-satir-a"><a href="/products/' + esc(x.u.h) + "?variant=" + x.u.v + '" target="_blank" rel="noopener">' + esc(kisaAd(x.u.ad)) + '</a><small>' + esc(x.aciklama) + '</small></div>' +
          '<div class="ak-satir-f"><span>' + x.adet + " × " + tl(x.u.p) + "</span><b>" + tl(x.satir) + "</b></div>";
        tb.appendChild(a);
      });
      kart.appendChild(tb);
      set.uyari.forEach(function (u) { kart.appendChild(el("div", "ak-uyari", esc(u))); });
      var top = el("div", "ak-toplam");
      top.innerHTML = "<span>Set toplamı<small>KDV dahil · ürün sayfasındaki fiyatların toplamı</small></span><b>" + tl(set.toplam) + "</b>";
      kart.appendChild(top);
      var msg = el("div", "ak-msg");
      var sb = el("button", "ak-btn tam", "Tüm seti sepete ekle"); sb.type = "button";
      sb.onclick = function () { sepeteEkle(set, sb, msg); };
      kart.appendChild(sb);
      var wa1 = el("a", "ak-btn wa tam", "Bu seti WhatsApp'tan sor"); wa1.href = waSet(set); wa1.target = "_blank"; wa1.rel = "noopener"; wa1.id = "ak-wa-set";
      kart.appendChild(wa1);
      kart.appendChild(msg);
    }
    set.not.forEach(function (u) { kart.appendChild(el("p", "ak-not", esc(u))); });
    if (set.bitrate) kart.appendChild(el("p", "ak-not", "Disk hesabı: " + set.bitrate.mp + "MP için " + set.bitrate.mbps + " Mbps/kamera (H.265, hareketli sahne, sürekli kayıt varsayımı)."));
    kart.appendChild(el("p", "ak-not", "Fiyatlar mağazadaki güncel satış fiyatıdır" + (set.canli ? " (kontrol " + set.canli.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" }) + ")" : "") + ". Montaj/kurulum hizmeti vermiyoruz; ürünler kurulum kılavuzuyla gönderilir."));
    kutu.appendChild(kart);

    // YOL 1 — İhtiyaç listesi -> WhatsApp
    var k2 = el("section", "ak-kart ikinci");
    k2.appendChild(el("h2", "ak-h2", "İhtiyaç listenizi WhatsApp'tan gönderin"));
    k2.appendChild(el("p", "ak-alt", "Seçimleriniz aşağıdaki mesaj olarak hazırlanır; WhatsApp açılınca yalnız gönder'e basmanız yeterli."));
    var on = el("pre", "ak-onizle"); on.textContent = metinIhtiyac(); k2.appendChild(on);
    var wa2 = el("a", "ak-btn wa tam", "İhtiyaç listemi WhatsApp'tan gönder"); wa2.href = waIhtiyac(); wa2.target = "_blank"; wa2.rel = "noopener"; wa2.id = "ak-wa-ihtiyac";
    k2.appendChild(wa2);
    if (PHONE) { var ara = el("a", "ak-btn ikincil tam", "Telefonla sorun: " + esc(PHONE)); ara.href = "tel:" + PHONE.replace(/\s/g, ""); k2.appendChild(ara); }
    if (!tam) { kutu.insertBefore(k2, kart); kutu.insertBefore(el("div", "ak-dur", "<b>Stoktaki ürünlerle bu seçime tam uyan set kurulamadı</b> (eksik: " + esc(set.eksik.join(", ")) + "). İhtiyaç listenizi WhatsApp'tan gönderin; alternatifle ya da tedarikle dönelim."), k2); } else kutu.appendChild(k2);

    gezinti(kutu, 3, null);
    var yeni = el("button", "ak-btn ikincil tam", "Baştan başla"); yeni.type = "button"; yeni.onclick = function () { st = yeniDurum(); ciz(); };
    kutu.appendChild(yeni);
  }

  window.__axinKur = {
    ayarla: function (o) { for (var k in o) st[k] = o[k]; st.haric = {}; },
    kur: kur, durum: function () { return st; }, veri: function () { return D; },
    waIhtiyac: waIhtiyac, waSet: function () { return sonSet ? waSet(sonSet) : null; },
    sonSet: function () { return sonSet; }, git: git, metinIhtiyac: metinIhtiyac
  };
})();
